import * as React from 'react'

import { filterOutGoogleQueryParams } from './utils'

import './SystemMessage.sass'

type Props = { message: Models.Message; text?: never } | { text: string; message?: never }

const SystemMessage = (props: Props) => {
    const text = props.text ?? props.message!.text

    const messageText = text.includes('Patient Started chat on') ? filterOutGoogleQueryParams(text) : text

    return (
        <div className="actions-container">
            <div className="line-before"></div>
            <div className="message system-message">{messageText}</div>
            <div className="line-after"></div>
        </div>
    )
}

export default SystemMessage
